import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FlaskConical, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="mt-24 border-t border-slate-200 bg-[#0F2942] text-slate-200">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 py-14 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
              <FlaskConical className="h-5 w-5 text-teal-300" />
            </div>
            <div className="leading-tight">
              <div className="text-base font-bold text-white" style={{ fontFamily: "Outfit, sans-serif" }}>HiCare Lab Solutions</div>
              <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-teal-300">Precision · Trust · Service</div>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-300">{t("footer.tagline")}</p>
        </div>

        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-300">Explore</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/products" className="hover:text-white">{t("nav.products")}</Link></li>
            <li><Link to="/refurbished" className="hover:text-white">{t("nav.refurbished")}</Link></li>
            <li><Link to="/services" className="hover:text-white">{t("nav.services")}</Link></li>
            <li><Link to="/about" className="hover:text-white">{t("nav.about")}</Link></li>
            <li><Link to="/contact" className="hover:text-white">{t("nav.contact")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-300">Contact</div>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="mt-0.5 h-4 w-4 text-teal-300" /> +91 78755 55877</li>
            <li className="flex items-start gap-2"><Mail className="mt-0.5 h-4 w-4 text-teal-300" /> hicarelabsolutions@gmail.com</li>
            <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 text-teal-300" /> Pune, Maharashtra, India</li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-300">Certifications</div>
          <div className="mt-4 flex flex-wrap gap-2">
            {["ISO 9001", "CE", "GST Reg.", "NABL Aligned"].map((c) => (
              <span key={c} className="rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs">{c}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-5 text-xs text-slate-400 md:flex-row">
          <div>© {new Date().getFullYear()} HiCare Lab Solutions. {t("footer.rights")}</div>
          <div>hicarelabsolution.com</div>
        </div>
      </div>
    </footer>
  );
}
